import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "form-row" }
const _hoisted_4 = { class: "form-group col-md-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "inputEmail4" }, "Code", -1)
const _hoisted_6 = { class: "form-group col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { for: "username" }, "Name", -1)
const _hoisted_8 = { class: "form-row" }
const _hoisted_9 = { class: "form-group col-md-6" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h4", null, "Permissions", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { for: "inputEmail4" }
const _hoisted_13 = {
  key: 0,
  class: "form-check"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_15 = { class: "form-group col-md-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "username" }, "상태", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("option", {
  value: "1",
  selected: ""
}, "Active", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("option", { value: "0" }, "Disabled", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubmitButton = _resolveComponent("SubmitButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitform && _ctx.onSubmitform(...args)), ["prevent"]))
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.role_code = $event))
            }, null, 512), [
              [_vModelText, _ctx.role_code]
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.role_name = $event))
            }, null, 512), [
              [_vModelText, _ctx.role_name]
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupRoutes, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (index !== 'undefined')
                  ? (_openBlock(), _createBlock("div", _hoisted_11, [
                      _createVNode("h6", _hoisted_12, _toDisplayString(index), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (route, i) => {
                        return (_openBlock(), _createBlock("div", { key: i }, [
                          (typeof route.meta.text !== 'undefined')
                            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                                _withDirectives(_createVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: 'inlineCheckbox' + index + i,
                                  value: 
                        route.name +
                          '@' +
                          route.meta.serverRoute +
                          '@' +
                          route.meta.text
                      ,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.permissions = $event))
                                }, null, 8, ["id", "value"]), [
                                  [_vModelCheckbox, _ctx.permissions]
                                ]),
                                _createVNode("label", {
                                  class: "form-check-label",
                                  for: 'inlineCheckbox' + index + i
                                }, _toDisplayString(route.meta.text), 9, ["for"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_15, [
            _hoisted_16,
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.status = $event)),
              class: "form-control"
            }, [
              _hoisted_17,
              _hoisted_18
            ], 512), [
              [_vModelSelect, _ctx.status]
            ])
          ])
        ]),
        _createVNode(_component_SubmitButton, {
          text: "생성",
          loadingText: " Saving...",
          isSubmitting: _ctx.isSubmitting
        }, null, 8, ["isSubmitting"])
      ], 32)
    ])
  ]))
}